<template>
    <div>
        <div class="card">
            <div class="bg-blue-light px-1 rounded pb-2">
                <TitleButton
                    class="mt-1"
                    btnTitle="Go Back"
                    title="Create Payment"
                    @onClickCloseButton="goToList"
                />

                <div class="row mt-1">
                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                        <label for="colFormLabel" class="col-form-label">Date</label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="date"
                            placeholder=""
                            v-model="payment.date"
                        >
                    </div>

                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                        <label for="colFormLabel" class="col-form-label">Paid from: </label>
                        <v-select
                            placeholder="Select Cash & Bank Account"
                            class="w-100"
                            v-model="credit.account_head_id"
                            :options="cashAndBack"
                            label="name"
                            :reduce="name => name.id"
                        />
                    </div>

                    <div class="col-12 col-sm-6 col-md-4 col-lg-3">

                        <div class="d-flex align-items-center justify-content-between filter-label">
                            <label for="colFormLabel" class="col-form-label">Party: </label>
                            <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                                <i class="fas fa-search"></i>
                            </span>
                        </div>

                        <AsyncSelect
                            placeholder="Select Party"
                            v-model="contactProfile"
                            :api-service="fetchContactProfiles"
                            :format-label="formatPatientLabel"
                        />
                    </div>

                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                    <label for="colFormLabel" class="col-form-label text-end">Business</label>
                    <v-select
                        placeholder="Select Business"
                        class="w-100"
                        :options="businesses"
                        label="name"
                        :reduce="name => name.id"
                        v-model="payment.business_id"
                    />
                    </div>
                </div>
            </div>
            <div class="px-2 mt-2">
                <AddFormElement
                    class="mb-2"
                    :accountHeads="accountHeads"
                    v-for="(item, index) in payment.general_ledgers"
                    :key="index"
                    :index="index"
                    :item="item"
                    @onClose="onClose"
                />

                <div class="row me-1 mt-3">
                    <div class="col-12 col-sm-4 col-lg-8 mb-1 mb-sm-0">
                        <AddButton title="Add line" @onClickAdd="onClickAdd"/>
                    </div>
                    <div class="col-6 col-sm-4 col-lg-4"><input readonly type="number" class="form-control text-end" :value="totalDebit"></div>
                    <!-- <div class="col-6 col-sm-4 col-lg-2"><input readonly type="number" class="form-control" :value="totalCredit"></div> -->
                </div>

                <div class="row mt-3">
                    <div class="col-12">
                        <div class="mb-2">
                            <label for="note" class="form-label fw-bold">Memo</label>
                            <textarea v-model="payment.note" placeholder="Memo" class="form-control" rows="2" id="note"></textarea>
                        </div>
                    </div>
                </div>

                <div class="my-2 text-center">
                    <hr class="mb-1">
                    <button
                        :disabled="paymentLoading || saveNewLoader"
                        @click="savePayment(true)"
                        class="btn btn-primary me-1"
                    >
                        <div v-if="paymentLoading" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Save
                    </button>
                    <button
                        :disabled="paymentLoading || saveNewLoader"
                        @click="savePayment(false)"
                        class="btn btn-primary me-1"
                    >
                        <div v-if="saveNewLoader" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Save & New
                    </button>
                    <button
                        :disabled="paymentLoading || saveNewLoader"
                        @click="savePayment(false, true)"
                        class="btn btn-primary me-1"
                    >
                        <div v-if="saveNewLoader" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Save & Print
                    </button>
                    <button
                        @click="goToList"
                        class="btn btn-outline-secondary cancel-btn"
                    >
                        Cancel
                    </button>
                </div>
          </div>
        </div>
        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            :isFilterable="true"
            :companyRoles="companyRoles"
        />
    </div>
</template>

<script>
import handlePayment from '@/services/modules/payment'
import { inject } from 'vue'
import TitleButton from '@/components/atom/TitleButton'
import AddFormElement from '@/components/molecule/company/payment/AddFormElement'
import AddButton from '@/components/atom/AddButton'
import handleContact from '@/services/modules/contact'
import handleCBusinesses from '@/services/modules/businesses'
import figureFormatter from "@/services/utils/figureFormatter";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import Pagination from "@/components/atom/Pagination.vue";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleRole from "@/services/modules/role";
import {useStore} from "vuex";
import pdfPrinterHelper from "@/services/utils/pdfPrinterHelper";
import handleJournal from '@/services/modules/journal'

export default {
    name: 'PaymentCreate',
    components: {
        ContactDropdownFilter,
        Pagination,
        AsyncSelect,
        TitleButton,
        AddFormElement,
        AddButton
    },
    data: () => ({
        cashAndBack: [],
        accountHeads: [],
        businesses : [],
        saveNewLoader: false,
        companyRoles: [],
        contactProfile: null,
        paymentRes: {},
        credit: {
            account_head_id: null
        },
        payment: {
            company_id:'',
            contact_profile_id: null,
            business_id: null,
            date: '',
            note: '',
            mop_references: 'mop',
            voucher_type: 'payment_voucher',
            general_ledgers: [
                {
                    account_head_id: null,
                    debit: null,
                    credit: null,
                    note: '',
                    tax_rate: null,
                    taxable_amount: null
                },
                {
                    account_head_id: null,
                    debit: null,
                    credit: null,
                    note: '',
                    tax_rate: null,
                    taxable_amount: null
                }
            ]
        }
    }),
    computed: {
        isLoading () {
            return this.paymentLoading || this.saveNewLoader
        },
        start () {
            return this.$route.query.start
        },
        end () {
            return this.$route.query.end
        },
        general () {
            return this.payment.general_ledgers
        },
        totalDebit () {
            let total = 0;
            this.general.map(i => {
                if(i.debit) total += i.debit
            })
            return total
        }
    },

    watch: {
        contactProfile(newContact) {
            if(newContact) {
                this.payment.contact_profile_id = newContact.id;
            }
        }
    },
    
    methods: {
        
        async getCashAndBank() {
           // return;
            try {
                this.paymentLoading = true
                let res = await this.fetchCashAndBank(this.$route.params.companyId)
                if(!res.status) {
                    this.showError(res.message)
                }
                if(res.status) {
                    this.cashAndBack = res.data
                }
            } catch (err) {
                if(!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                }
                if(err.response) {
                    this.showError(err.response.message)
                }
            } finally {
                this.paymentLoading = false
            }
        },

        async getAccountHeads() {
            try {
              this.loading = true
              let accountHeadQuery = '?company_id=' + this.$route.params.companyId + '&cash_bank_hide=yes&status=active';
              let res = await this.fetchAccountHeadsList(accountHeadQuery)
                if(!res.status) {
                    this.showError(res.message)
                }
                if(res.status) {
                    this.accountHeads = res.data
                }
            } catch (err) {
                if(!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                }
                if(err.response) {
                    this.showError(err.response.message)
                }
            } finally {
                this.loading = false
            }
        },

        async getBusinesses(){
          try {
            let companyId = this.$route.params.companyId
            let res = await this.fetchBusinessList('?company_id=' + companyId)

            if(res.status) {
              this.businesses = res.data;
            }

          } catch (err) {
            if(!err.response) {
              this.showError('Something is wrong. Check your connectivity!!')
            }
            if(err.response) {
              this.showError(err.response.message)
            }
          } finally {
            this.loading = false
          }

        },

        onOpenContactSearchModal () {
            this.$store.state.isModalOpenThree = true;
        },

        setVoucherNumberAndDate(withoutDate = false) {
            new Promise(async (resolve, reject) => {
                try {
                    if(! withoutDate) {
                        this.payment.date = new Date().toISOString().split('T')[0]
                    }
                    resolve();
                } catch (err) {
                    reject(err);
                }
            })

        },

        goToList() {
            this.$router.push({name: 'payment-voucher-list', 
                params: {
                    companyId: this.$route.params.companyId,
                    moduleId: this.$route.params.moduleId,
                    menuId: this.$route.params.menuId,
                    pageId: this.$route.params.pageId
                },
                query: {
                    start: this.start,
                    end: this.end
                }
            
            })
        },
        onClose(index) {
            this.payment.general_ledgers.splice(index, 1)
        },
        onClickAdd() {
            this.payment.general_ledgers.push({
                account_head_id: null,
                debit: null,
                credit: null,
                note: '',
                tax_rate: null,
                taxable_amount: null
            })
        },
        async resetForm() {
            this.payment = {
                company_id:'',
                date: '',
                note: '',
                contact_profile_id: null,
                business_id: null,
                mop_references: 'mop',
                voucher_type: 'payment_voucher',
                general_ledgers: [
                    {
                        account_head_id: null,
                        debit: null,
                        credit: null,
                        note: '',
                        tax_rate: null,
                        taxable_amount: null
                    },
                    {
                        account_head_id: null,
                        debit: null,
                        credit: null,
                        note: '',
                        tax_rate: null,
                        taxable_amount: null
                    }
                ]
            }

            this.credit = {
                account_head_id: null
            }

            await this.setVoucherNumberAndDate()
        },
        getFormData () {
            let formData = new FormData();
          this.payment.mop_account_head_id = this.credit.account_head_id
            Object.keys(this.payment).forEach(i => {
                if(i !== 'general_ledgers') {
                    formData.append(i, this.payment[i])
                }
            })

            let mop_account_head_id = this.credit.account_head_id;
            let generalLedgerData = this.general.map((ledger) => {
              ledger.mop_account_head_id = mop_account_head_id;
              ledger.contact_profile_id = this.payment.contact_profile_id;
              ledger.business_id = this.payment.business_id;
              return ledger
            })
            generalLedgerData.push({
                account_head_id: this.credit.account_head_id,
                debit: null,
                credit: this.totalDebit,
                note: this.payment.note,
                tax_rate: null,
                taxable_amount: null,
                contact_profile_id: this.payment.contact_profile_id,
                business_id: this.payment.business_id
            })
            formData.append('general_ledgers', JSON.stringify(generalLedgerData))
            return formData;
        },
        async savePayment (redirect = false, print = false) {//createPayment
            this.payment.company_id = this.$route.params.companyId;
            let data = this.getFormData();
            if(redirect) {
                this.paymentLoading = true
            } else {
                this.saveNewLoader = true
            }
            try {
                let res = await this.createPayment(data)
                if(!res.status) {
                    this.showError(res.message)
                }
                if(res.status) {
                    this.showSuccess(res.message)
                    await this.resetForm()
                    if(redirect) this.goToList()
                    if(print) this.goToPrint(res.data.id)
                }
            } catch (err) {
                if(!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                    return ;
                }

                if(err.response && err.response.status !== 406) {
                    this.showError(err.response?.data.message)
                }
            } finally {
                this.paymentLoading = false
                this.saveNewLoader = false
            }
        },
        async getCompanyRoles () {
            const res = await this.fetchCompanyDefaultRoles(`?company_id=${this.$route.params.companyId}`);
            if (res.status) {
                this.companyRoles = res.data
            }
        },
        onSearchContact (contact) {
            this.contactProfile = contact
        },
        goToPrint(id) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            this.fetchSinglePayment(id, companyQuery).then( (res) => {
                if(res){
                    this.paymentRes = res.data;
                }}).then (() => {
                this.generatePdf(this.$route.params.companyId, this.paymentRes, 'payment')
            }).catch((err) => {
                console.log('Something went wrong');
            })
        },
    },
    setup() {
        const showError =  inject('showError');
        const showSuccess =  inject('showSuccess');
        const {decimalFormat} = figureFormatter();
        const store = useStore()
        const { generatePdf } = pdfPrinterHelper();
        const {fetchAccountHeadsList} = handleJournal()

        const {
            createPayment,
            fetchCashAndBank,
            paymentLoading,
            fetchSinglePayment
        } = handlePayment()

        const {
          fetchContactProfiles,
        } = handleContact()

        const {
          fetchBusinessList,
        } = handleCBusinesses()

        const { formatPatientLabel } = useAsyncDropdownHelper();
        const { fetchCompanyDefaultRoles } = handleRole();

        return {
            store,
            fetchAccountHeadsList,
            createPayment,
            fetchCashAndBank,
            paymentLoading,
            showError,
            decimalFormat,
            fetchContactProfiles,
            fetchBusinessList,
            showSuccess,
            generatePdf,
            formatPatientLabel,
            fetchSinglePayment,
            fetchCompanyDefaultRoles
        }
    },

    async mounted() {
        await this.getCashAndBank()
        await this.getAccountHeads()
        await this.getBusinesses()
        await this.setVoucherNumberAndDate()
        await this.getCompanyRoles()
    }
}
</script>

<style scoped>
    .cancel-btn{
        background-color: #F0F2F5; color: #7D7D7D;
    }
    .cancel-btn:hover{
        background-color: #e9edf5;
    }
    hr{
        margin: 0 -3%;
        width: 106%;
    }
</style>
